import CloseIcon from '@mui/icons-material/Close'
import { isPresent } from '@jjvgaming/player-payback-library'
import { Box, type Theme, Typography, type SxProps } from '@mui/material'
import { useEffect, useRef, type MutableRefObject, useCallback } from 'react'
import { useHeightActiveModalHeader } from 'stores/useHeightActiveModalHeader'

const commonSxModalProps: SxProps<Theme> = {
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  backgroundColor: 'rgba(247, 247, 246, 1)',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  borderBottom: '1px solid #e5e7eb',
}

export const ModalFullHeader = ({
  showIconClose,
  toggleIsOpen,
  title,
  subTitle,
  subTitle2,
}: {
  showIconClose?: boolean
  toggleIsOpen: () => void
  title?: string
  subTitle?: string
  subTitle2?: string
}) => {
  const ref: MutableRefObject<HTMLDivElement | null> = useRef(null)
  const setHeightModalHeader = useHeightActiveModalHeader(
    (state) => state.setHeight
  )
  const adjustHeight = () => {
    if (ref.current) {
      setHeightModalHeader(ref.current.offsetHeight)
    }
  }

  const onResize = useCallback(() => {
    adjustHeight()
  }, [])

  useEffect(() => {
    window.addEventListener('resize', onResize)
    onResize()
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return (
    <Box sx={commonSxModalProps} ref={ref}>
      <Box px={{ xs: 1, sm: 4 }} py={{ xs: 2, sm: 3 }} className="w-[100%]">
        {isPresent(title) && (
          <Typography variant="h2" fontWeight={'bold'}>
            {title}
          </Typography>
        )}
        {isPresent(subTitle) && (
          <Box>
            <Typography variant="body-1">{subTitle}</Typography>
            <Typography variant="body-1">{subTitle2}</Typography>
          </Box>
        )}
      </Box>
      <Box
        onClick={toggleIsOpen}
        sx={{ cursor: 'pointer' }}
        className="w-[20%]"
      >
        {isPresent(showIconClose) && <CloseIcon />}
      </Box>
    </Box>
  )
}
